import { render, staticRenderFns } from "./ReservaFormularioMovil.vue?vue&type=template&id=f20ba65e&"
import script from "./ReservaFormularioMovil.vue?vue&type=script&lang=js&"
export * from "./ReservaFormularioMovil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports